import { useHistory } from 'react-router-dom';
import { Icon, P, Image } from '@fashionnovateam/nova-ui-toolkit';
import cn from 'classnames';
import { ItemFilters, VendorCatalogItem } from '../../../Lib/Hooks/ItemService';
import { useGetItemPhotoURLs } from '../../../Lib/Hooks/ItemService/useGetItemPhotoURLs';

export function SidebarListItem({
  item,
  currentItemId,
  userId,
  index,
  searchParams = '',
}: {
  item: VendorCatalogItem;
  currentItemId: string;
  userId: string;
  index: number;
  searchParams?: string;
}) {
  const history = useHistory();
  const { data: photoUrls } = useGetItemPhotoURLs(userId, item.id);

  const frontImageThumbnailUrl = photoUrls?.front_photo?.thumbnail_url ?? '';
  const frontImageUrl = photoUrls?.front_photo?.url ?? '';

  return (
    <button
      data-index={index}
      data-testid="item-link"
      type="button"
      onClick={() =>
        history.push(`/users/${userId}/sell-to-us/${item.id}${searchParams}`)
      }
      className={cn(
        'w-full text-left px-2 py-1 flex flex-row items-center gap-2 border-b rounded-md border-neutral-100',
        {
          'bg-neutral-200': currentItemId === item.id,
        },
      )}
    >
      <div className="flex flex-row items-center gap-3 min-w-0 flex-1">
        <div className="rounded overflow-hidden w-8 h-10 relative inline-block flex-shrink-0">
          <Image
            key={
              frontImageThumbnailUrl ||
              frontImageUrl ||
              'front-image-placeholder'
            }
            className="object-cover w-full h-full"
            alt="front"
            src={frontImageThumbnailUrl}
            fallbackSrc={frontImageUrl}
            loading="lazy"
            decoding="async"
          />
        </div>
        <P size="xs" weight="normal" color="primary" className="truncate">
          {item.style_number}
        </P>
      </div>
      {item.stage === ItemFilters.REJECTED ||
      item.stage === ItemFilters.PO_CREATED ? null : (
        <Icon
          className="ml-auto flex-shrink-0"
          name="three-dots-menu/three-dots-menu-horizontal-circle"
        />
      )}
    </button>
  );
}
